module.exports = require('../dist/front-hub-react.js')
